import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import CookieConsent from "./components/CookieConsent";
import Home from "./pages/Home";
import TestsPage from "./pages/TestsPage";
import NaturalIntelligenceTest from "./pages/NaturalIntelligenceTest";
import IntelligenceTypesTest from "./pages/IntelligenceTypesTest";
import BelbinTest from "./pages/BelbinTest";
import ORSTest from "./pages/ORSTest";
import SubtypeTest from "./pages/SubtypeTest";
import TestResult from "./pages/TestResult";
import ThankYouPage from "./pages/ThankYouPage";
import CookiePolicy from "./pages/CookiePolicy";
import Footer from "./components/Footer"

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <div className="min-h-screen bg-gray-50">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/tests" element={<TestsPage />} />
            <Route path="/tests/natural-intelligence" element={<NaturalIntelligenceTest />} />
            <Route path="/tests/intelligence-types" element={<IntelligenceTypesTest />} />
            <Route path="/tests/belbin" element={<BelbinTest />} />
            <Route path="/tests/ors" element={<ORSTest />} />
            <Route path="/tests/subtype" element={<SubtypeTest />} />
            <Route path="/results/:resultId" element={<TestResult />} />
            <Route path="/thank-you" element={<ThankYouPage />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
          </Routes>
        </div>
        <Footer/>
        <CookieConsent />
      </BrowserRouter>
    </div>
  );
}

export default App;